import { render } from "./aboutView.vue?vue&type=template&id=496a67b5"
const script = {}

import "./aboutView.vue?vue&type=style&index=0&id=496a67b5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__